import React from "react"

import DesktopProductImages from "./DesktopProductImages"
import MobileProductImages from "./MobileProductImages"

export type MuxVideo = {
  title: string
  video: {
    assetId: string
    audioOnly: boolean
    created_at: number
    duration: number
    max_stored_frame_rate: number
    max_stored_resolution: string
    playbackId: string
    ratio: string
    ready: boolean
    version: number
  }
}

interface ProductImagesProps {
  currentVariant: {
    images: Array<string>
    name?: string // Variant color/name for alt text
  }
  /** Device name for alt text (e.g., "iPhone 16 Pro Max") */
  deviceName?: string
  imageGalleryMuxVideos?: Array<MuxVideo>
  images: Array<string>
  lifestyleMuxVideos?: Array<MuxVideo>
  /** Product name for alt text (e.g., "Pathfinder", "Monarch Pro") */
  productName?: string
}

const ProductImages = (props: ProductImagesProps) => (
  <>
    <DesktopProductImages {...props} initialDesktopImages={3} />
    <MobileProductImages {...props} />
  </>
)

export default ProductImages
